var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.59 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6c63ff;}.cls-2{fill:#3f3d56;}.cls-3{fill:#f2f2f2;}.cls-4{opacity:0.1;isolation:isolate;}.cls-5{fill:#a0616a;}.cls-6{fill:#2f2e41;}.cls-7{fill:#ff8080;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.86,102.57c0,13.57-8.07,18.31-18,18.31s-18-4.74-18-18.31,18-30.84,18-30.84S154.86,89,154.86,102.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.36 107.44 144.04 93.39 136.39 105.66 136.47 100.55 141.77 90.39 136.5 99.2 136.65 90.01 142.31 81.92 136.67 88.57 136.76 71.72 136.2 93.07 130.46 84.28 136.13 94.87 135.59 105.13 135.58 104.86 128.93 95.57 135.56 105.82 135.49 107.11 135.48 107.12 135.49 107.23 134.12 120.92 135.94 120.92 136.16 119.82 142.77 109.59 136.18 118.81 136.36 107.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.59,58.92c0,25.93-15.42,35-34.43,35s-34.43-9.05-34.43-35S182.15,0,182.15,0,216.59,33,216.59,58.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.9 89.94 181.25 68.24 195.93 41.39 181.31 64.83 181.47 55.07 191.58 35.65 181.51 52.49 181.51 52.49 181.79 34.94 192.63 19.48 181.84 32.18 182.02 0 180.9 42.6 180.99 40.84 169.98 23.99 180.81 44.22 179.79 63.82 179.76 63.3 167.06 45.56 179.72 65.14 179.59 67.59 179.57 67.63 179.58 67.83 176.97 117.56 180.45 117.56 180.87 91.87 193.49 72.34 180.9 89.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.17,113.21C215.17,121,165,150,106.27,150S0,135,0,127.23s46.41,1.46,105.1,1.46S215.17,105.47,215.17,113.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.17,113.21C215.17,121,165,150,106.27,150S0,135,0,127.23s46.41,1.46,105.1,1.46S215.17,105.47,215.17,113.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.17,113.21c0,7.74-50.21,28-108.9,28S0,135,0,127.23s46.41-7.3,105.1-7.3S215.17,105.47,215.17,113.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 107.46,
    cy: 128.7,
    rx: 45.13,
    ry: 3.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.71,58.75s13.21.24,10.77,2.57-11.62,0-11.62,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.18,30.52s5.33-1,7.19,3.35S57,50.46,57,50.46s10.19,6.75,12,6.53,5,.23,4.44,2.25-.32,4.32-1.66,4.6-3.47-2.4-5.1-1.11S50.62,59.3,49.69,58.32,41,36.16,41,36.16,41.32,30.45,44.18,30.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "55.62 121.44 56.24 126.58 51.1 127.93 48.16 126.58 48.16 122.06 55.62 121.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.8 124.75 42.41 129.89 37.27 131.23 34.34 129.89 34.34 125.36 41.8 124.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.11,65.29l2.32,8.44,3.43,17.13a16.87,16.87,0,0,1-1,9.17c-2,5-5.5,21.41-4.77,22.39s-8.32,1.71-8.2.73,1.35-14.44,1.35-14.44S51,96.86,51.83,95.39s-3.91-5.14-3.91-5.14-1.22,14.07-3.06,15.29S43.27,125.73,42.41,126s-7.1,1.22-7.83,0,0-21.65,0-21.65,4.16-15.54,3.3-17.74S37.52,75,37.52,75s-3.18-7.22-1.47-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.75,18.32s-5.14,6.36-4.89,9.17-8.07-5.14-8.07-5.14,6-8.07,6-9.79S55.75,18.32,55.75,18.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 55.69,
    cy: 12.63,
    r: 8.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.34,60.72a14.83,14.83,0,0,0-.75,4.21c0,.84,2.28,1.4,5.37,1.76,2.87.34,6.47.51,9.75.6,3.44.09,6.52.09,8,.09,4.4,0,.86-2.81-.86-4.16S55.5,42.79,55.62,40.34s-1.1-9.54-1.1-10.89-2.88-4.86-2.88-4.86-.67,1.92-3.36-.65A14.3,14.3,0,0,0,42,20.64c-2.69,1-7.22,11.74-7.46,13.58-.1.74,0,4.56.15,8.92.24,6.37.66,13.89,1,14.69A5.82,5.82,0,0,1,35.34,60.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.41 67.86 49.26 70.92 45.96 74.35 44.86 69.58 48.41 67.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.51,125.24s2.57,2.94,4.53,1,1.84-3.18,2.2-3.18,5.87,4.89,5.87,4.89,9.42,2.2,4.28,3.79-19.7.49-19.7,0-.37-7,1-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.68,128.54s2.57,2.94,4.53,1,1.84-3.18,2.2-3.18,5.87,4.89,5.87,4.89,9.42,2.2,4.28,3.79-19.7.49-19.7,0-.37-7,1-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.62,19.08c-.26.17-.6.34-.86.17a39,39,0,0,1-2.17-7.5,3.67,3.67,0,0,1,.22-2.67,6.56,6.56,0,0,0,.63-.88,6,6,0,0,0,.15-1.62A3.22,3.22,0,0,1,46.9,4.26a30.37,30.37,0,0,0,3.28-1,25,25,0,0,0,2.67-1.88A3.43,3.43,0,0,1,55.92.76c.89.36,1.45,1.27,2.29,1.73A6.69,6.69,0,0,0,60.1,3,12,12,0,0,1,65,5.3a3.54,3.54,0,0,1,.89.92c1.08,1.78-.86,4.21,0,6.11L64,10.87a6.44,6.44,0,0,0-1.65-1.05,2.18,2.18,0,0,0-1.9.09,3.93,3.93,0,0,0-1.27,2.38c-.27.88-.88,1.85-1.8,1.83-1.25,0-1.69-1.78-2.81-2.33a2.17,2.17,0,0,0-2.28.4A4.67,4.67,0,0,0,51,14.24a5.6,5.6,0,0,1-.64,1.44c-.34.46-.77.5-1.12.84A17.67,17.67,0,0,1,46.62,19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.34,60.72a57,57,0,0,0,4.62,6c2.87.34,6.47.51,9.75.6a7.73,7.73,0,0,0-2.16-2c-1.59-1-5.38-12.6-5.38-12.6s4.65-12,5.87-16.51-3.55-7.1-3.55-7.1c-2.2-1.84-6,2.45-6,2.45s-1.94,5.84-3.77,11.61c.24,6.37.66,13.89,1,14.69A5.82,5.82,0,0,1,35.34,60.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.12,28.11s4.77,2.57,3.55,7.1S41.8,51.72,41.8,51.72s3.79,11.62,5.38,12.6,3.79,3.3,2.08,4.53S46.33,72,45.1,71.41s-1.22-4-3.3-4S31.28,54.65,31.16,53.31s7-22.75,7-22.75S41.92,26.27,44.12,28.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.33,61.54,142,60.17a4.28,4.28,0,0,0-6.05,0L109.21,86.86,82.51,60.17a4.28,4.28,0,0,0-6.05,0l-1.38,1.38a4.28,4.28,0,0,0,0,6.05h0l26.69,26.69L75.08,121a4.28,4.28,0,0,0,0,6.05l1.38,1.38a4.28,4.28,0,0,0,6.05,0l26.69-26.69,26.69,26.69a4.28,4.28,0,0,0,6.05,0l1.38-1.38a4.28,4.28,0,0,0,0-6.05L116.64,94.29,143.33,67.6A4.28,4.28,0,0,0,143.33,61.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.13,122.44,100,96.53l-.25-.25L75.08,121A4.26,4.26,0,0,0,74.13,122.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.71,62.41a4.28,4.28,0,0,1,6.05,0h0L107.46,89.1l26.69-26.69a4.28,4.28,0,0,1,6.05,0h0l1.38,1.38a4.28,4.28,0,0,1,1,4.6l.79-.79a4.28,4.28,0,0,0,0-6.05h0L142,60.17a4.28,4.28,0,0,0-6.05,0L109.21,86.86,82.51,60.17a4.28,4.28,0,0,0-6.05,0l-1.38,1.38a4.26,4.26,0,0,0-1,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.89,94.54l-2,2,26.69,26.69a4.28,4.28,0,0,1,1,4.6l.79-.79a4.28,4.28,0,0,0,0-6.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.08,112.34c0,11.27-6.7,15.21-15,15.21s-15-3.94-15-15.21,15-25.62,15-25.62S31.08,101.06,31.08,112.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.72 116.39 22.1 104.72 15.74 114.91 15.81 110.67 20.21 102.22 15.83 109.54 15.96 101.91 20.66 95.19 15.97 100.71 16.05 86.72 15.59 104.45 10.82 97.15 15.53 105.95 15.08 114.47 15.07 114.24 9.55 106.53 15.05 115.04 15 116.11 14.99 116.12 14.99 116.21 13.86 127.58 15.37 127.58 15.55 126.66 21.04 118.17 15.57 125.82 15.72 116.39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxLinkExpired);
export default __webpack_public_path__ + "static/media/gfx-link-expired.98c9ecd2d159625612ca466a72e0e602.svg";
export { ForwardRef as ReactComponent };